import React from "react";
import { Row } from "react-bootstrap";

import MasterTouranment from "./MasterTournament";

import { isChildTournament } from "../../../../../../lib/utils";
import { useTournamentContext } from "../../contexts/Tournament";

const TDView = (): React.JSX.Element => {
    const { tournament } = useTournamentContext();
    const isMasterTournament = !isChildTournament(tournament);

    if (!isMasterTournament) {
        return <></>;
    }

    return (
        <Row>
            <MasterTouranment />
        </Row>
    );
};

export default TDView;
